var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "login-wechat-wap" }, [
        _vm.oauthType == "login" && _vm.isLoginFail
          ? _c("div", { staticClass: "login-wechat-wap-login" }, [
              _c("img", {
                staticClass: "login-wechat-wap-login-img",
                attrs: {
                  src:
                    "https://static2.evente.cn/static/img/loading201904171.gif",
                  alt: ""
                }
              })
            ])
          : _c("div", { staticClass: "login-wechat-wap-popup" }, [
              _vm.isChina
                ? _c("div", [
                    _c("h3", { staticClass: "login-wechat-wap-title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "login-wechat-wap-desc" }, [
                      _vm._v(_vm._s(_vm.desc))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "login-wechat-wap-close",
                        on: { click: _vm.popupClose }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "https://static2.evente.cn/static/img/login-icon-close2.png",
                            width: "100%"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-box" }, [
                      _c(
                        "div",
                        { staticClass: "login-wechat-wap-prefix-wraper" },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nowData.prefix,
                                  expression: "nowData.prefix"
                                }
                              ],
                              staticClass: "login-wechat-wap-prefix",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.nowData,
                                      "prefix",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    _vm.nowData.tel = ""
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.abroadDatas, function(data, dataIndex) {
                              return _c(
                                "option",
                                {
                                  key: dataIndex,
                                  domProps: { value: data.prefix }
                                },
                                [_vm._v("+" + _vm._s(data.prefix))]
                              )
                            })
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nowData.tel,
                            expression: "nowData.tel"
                          }
                        ],
                        ref: "telElem",
                        staticClass: "login-wechat-wap-input",
                        attrs: {
                          type: "number",
                          placeholder: _vm.telPlaceholder
                        },
                        domProps: { value: _vm.nowData.tel },
                        on: {
                          blur: _vm.telBlur,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.nowData, "tel", $event.target.value)
                            },
                            _vm.telInput
                          ]
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.smscode,
                            expression: "smscode"
                          }
                        ],
                        ref: "codeElem",
                        staticClass: "login-wechat-wap-input",
                        attrs: {
                          type: "tel",
                          maxlength: _vm.smscodeLength,
                          placeholder: _vm.smsPlaceholder
                        },
                        domProps: { value: _vm.smscode },
                        on: {
                          blur: _vm.codeBlur,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.smscode = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "login-wechat-wap-smscode-wraper",
                          on: { click: _vm.sendSmsCode }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                "login-wechat-wap-smscode",
                                {
                                  "login-wechat-wap-smscode-disabled":
                                    _vm.smsStatus ||
                                    _vm.sendText !== _vm.countEnd
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.sendText))]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-error" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errorShow,
                            expression: "errorShow"
                          }
                        ],
                        staticClass: "login-wechat-wap-error-img",
                        attrs: {
                          src:
                            "https://static2.evente.cn/static/img/login-icon-error1.png"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errorShow,
                              expression: "errorShow"
                            }
                          ],
                          staticClass: "login-wechat-wap-error-text"
                        },
                        [_vm._v(_vm._s(_vm.errorText))]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: [
                          "login-wechat-wap-button",
                          {
                            "login-wechat-wap-button-disabled":
                              _vm.loginOnFlg || _vm.btnText !== _vm.loginText
                          }
                        ],
                        on: { click: _vm.login }
                      },
                      [_vm._v(_vm._s(_vm.loginText))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-wechatbox" }, [
                      _vm.isWechat && !_vm.oauthType
                        ? _c("img", {
                            staticClass: "login-wechat-wap-wechatbox-img",
                            attrs: {
                              src:
                                "https://1img.evente.cn/9b/2a/d5/e9e0f3cdf63848a708b7285f92.jpg"
                            },
                            on: { click: _vm.wechatBind }
                          })
                        : _vm._e()
                    ])
                  ])
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "login-wechat-wap-close",
                        on: { click: _vm.popupClose }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "https://static2.evente.cn/static/img/login-icon-close2.png",
                            width: "100%"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h3",
                      { staticClass: "login-wechat-wap-english-title" },
                      [_vm._v("Ticket Buyer")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nowEnglishData.email,
                            expression: "nowEnglishData.email"
                          }
                        ],
                        staticClass: "login-wechat-wap-english-input",
                        attrs: { type: "email", placeholder: "Email Address" },
                        domProps: { value: _vm.nowEnglishData.email },
                        on: {
                          blur: _vm.emailBlur,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.nowEnglishData,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.smscode,
                            expression: "smscode"
                          }
                        ],
                        staticClass: "login-wechat-wap-english-input",
                        attrs: {
                          type: "tel",
                          maxlength: _vm.smscodeLength,
                          placeholder: "Security Code"
                        },
                        domProps: { value: _vm.smscode },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.smscode = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "login-wechat-wap-english-wraper",
                          on: { click: _vm.sendEnglishSmsCode }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                "login-wechat-wap-english-smscode",
                                {
                                  "login-wechat-wap-smscode-disabled":
                                    _vm.smsEnglishStatus ||
                                    _vm.sendEnglishText !== _vm.countEnglishEnd
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.sendEnglishText))]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-wechat-wap-error" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errorShow,
                            expression: "errorShow"
                          }
                        ],
                        staticClass: "login-wechat-wap-error-img",
                        attrs: {
                          src:
                            "https://static2.evente.cn/static/img/login-icon-error1.png"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errorShow,
                              expression: "errorShow"
                            }
                          ],
                          staticClass: "login-wechat-wap-error-text"
                        },
                        [_vm._v(_vm._s(_vm.errorEnglishText))]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: [
                          "login-wechat-wap-english-button",
                          {
                            "login-wechat-wap-button-disabled":
                              _vm.loginEnglishOnFlg ||
                              _vm.loginEnglishDefault !== _vm.loginEnglishText
                          }
                        ],
                        on: { click: _vm.loginEnglish }
                      },
                      [_vm._v(_vm._s(_vm.loginEnglishText))]
                    )
                  ])
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e0b5b20", { render: render, staticRenderFns: staticRenderFns })
  }
}